"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var kendo_react_intl_1 = require("@progress/kendo-react-intl");
var messages_1 = require("./../messages");
/**
 * @hidden
 */
var PagerInput = /** @class */ (function (_super) {
    __extends(PagerInput, _super);
    function PagerInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._text = undefined;
        _this.onChange = function (e) {
            var text = _this._text = e.target.value.replace(/\D/g, '');
            _this.forceUpdate();
            if (text) {
                _this.props.pageChange(parseInt(text, 10), e);
            }
        };
        _this.value = function () {
            var value = _this._text === undefined ? _this.props.currentPage.toString() : _this._text;
            _this._text = undefined;
            return value;
        };
        return _this;
    }
    PagerInput.prototype.render = function () {
        var _this = this;
        var intlService = kendo_react_intl_1.provideIntlService(this);
        var localizationService = kendo_react_intl_1.provideLocalizationService(this);
        var pageMessage = this.props.messagesMap ? this.props.messagesMap(messages_1.pagerPage) :
            ({ messageKey: messages_1.pagerPage, defaultMessage: messages_1.messages[messages_1.pagerPage] });
        var ofMessage = this.props.messagesMap ? this.props.messagesMap(messages_1.pagerOf) :
            ({ messageKey: messages_1.pagerOf, defaultMessage: messages_1.messages[messages_1.pagerOf] });
        var totalPagesMessage = this.props.messagesMap ? this.props.messagesMap(messages_1.pagerTotalPages) :
            ({ messageKey: messages_1.pagerTotalPages, defaultMessage: messages_1.messages[messages_1.pagerTotalPages] });
        return (React.createElement("span", { className: "k-pager-input k-label" },
            localizationService.toLanguageString(pageMessage.messageKey, pageMessage.defaultMessage),
            React.createElement("input", { className: "k-textbox", value: this.value(), onBlur: function () { return _this.forceUpdate(); }, onChange: this.onChange }), localizationService.toLanguageString(ofMessage.messageKey, ofMessage.defaultMessage) + " " + intlService
            .format(localizationService.toLanguageString(totalPagesMessage.messageKey, totalPagesMessage.defaultMessage), [
            this.props.totalPages
        ])));
    };
    return PagerInput;
}(React.Component));
exports.PagerInput = PagerInput;
kendo_react_intl_1.registerForLocalization(PagerInput);
//# sourceMappingURL=PagerInput.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/pager/PagerInput.js
// module id = 6501
// module chunks = 0